/*
 * Example article
 *
  {
    id: 1,
    title: 'The Test Article',
    slug: 'the_test_article',
    // Generated from https://www.unixtimestamp.com/
    published_at: 1516745276, // 01/23/2018 @ 10:07pm (UTC)
    featured: true,
    image: 'test-article.jpg',
    author_name: 'Cale Crawford',
    author_title: 'Developer',
    author_image: 'cale.jpg',
    preview:
      `Lorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse varius enim in
      eros elementum tristique. Duiscursus, mi quis viverra ornare, eros dolor interdum nulla,
      ut commodo diam libero vitae erat. Aenean faucibus nibhet justo cursus id rutrum lorem
      imperdiet. Nunc ut sem vitae risus tristique posuere.`,
    content: 'the-test-article.md',
  },
 *
 *
*/
const customerList = [
  {
    id: 3,
    name: 'AIWA',
    image: 'aiwa.png',
    class: 'med',
  },
  {
    id: 12,
    name: 'Aramark',
    image: 'aramark.png',
    class: 'reg',
  },
  {
    id: 8,
    name: 'Cedars-Sinai Medical Center',
    image: 'cedars-sinai.png',
    class: 'reg',
  },
  {
    id: 1,
    name: 'Chartwells Higher Education',
    image: 'chartwells.png',
    class: 'lg',
  },
  {
    id: 2,
    name: 'Compass Group',
    image: 'compass-group.png',
    class: 'reg',
  },
  {
    id: 11,
    name: 'Flik',
    image: 'flik.png',
    class: 'mini',
  },
  {
    id: 5,
    name: 'Fluor',
    image: 'fluor.png',
    class: 'reg',
  },
  {
    id: 10,
    name: 'Gourmet Dining',
    image: 'gourmet.png',
    class: 'lg',
  },
  {
    id: 4,
    name: 'Kenwood',
    image: 'kenwood.png',
    class: 'reg',
  },

  {
    id: 6,
    name: 'Thompson Hospitality',
    image: 'thompson.png',
    class: 'med',
  },
  {
    id: 9,
    name: 'TRD',
    image: 'trd.png',
    class: 'med',
  },
  {
    id: 7,
    name: 'Vertex Standard',
    image: 'vertex-standard.png',
    class: 'med',
  },
]

export default {
  getCustomers(cb) {
    setTimeout(() => cb(customerList), 0)
  },
}
